import classNames from 'classnames/bind';
import { Grid as GridBase } from 'forkedlibraries/react-bootstrap';
import PropTypes from 'prop-types';
import styles from './Grid.module.css';

const cx = classNames.bind(styles);

/**
 * Stated here, mirroring the `propTypes` and `defaultProps` blocks below,
 * because neither reaches the JSX checker: `...rest` gives the props an index
 * signature and React's prop transforms bail out on that, so `extraPadding` was
 * inferred as required. The index signature stands for the props `...rest`
 * forwards to `GridBase`.
 *
 * @param {{ extraPadding?: boolean } & Record<string, any>} props
 */
const Grid = ({ extraPadding, ...rest }) => (
  <GridBase className={cx({ extraPadding })} {...rest} />
);

export const gridPropsShape = {
  extraPadding: PropTypes.bool,
  fluid: PropTypes.bool,
};

Grid.propTypes = {
  ...gridPropsShape,
};

Grid.defaultProps = {
  extraPadding: false,
  fluid: false,
};

export default Grid;
